import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { orderBy } from 'lodash';
import { ProgramConsumer } from '../../contexts/ProgramContext';
import ProgramCard from './components/ProgramCard';

import './Program.scss';

export const Program = ({
  loadProgram,
  talks,
  selectedTalk,
  speakers,
  setSelectedTalk,
  isLoading
}) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    loadProgram();
    if (history.action !== 'POP') {
      window.scrollTo(0, 0);
      setSelectedTalk('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderDayColumn = (column, day) => {
    const orderedSlots = column.length > 0 ? orderBy(column, ['startTime'], 'asc') : [];
    let dayTitle = '';
    switch (day) {
      case 'day2':
        dayTitle = 'Thursday Oct. 15th';
        break;
      case 'day3':
        dayTitle = 'Friday Oct. 16th';
        break;
      default:
        dayTitle = 'Wednesday Oct. 14th';
        break;
    }
    return (
      <div key={day} className="column is-4 is-12-touch">
        <h2 className={`day-title ${day}-color`}>{dayTitle}</h2>
        {orderedSlots.map(slot => {
          const speakerNames = [];
          if (slot.speakers) {
            slot.speakers.forEach(speakerId => {
              const foundSpeaker = speakers.find(sp => sp.id === speakerId) || {};
              if (foundSpeaker && foundSpeaker.name) {
                speakerNames.push(foundSpeaker.name);
              }
            });
          }
          if (day === 'day1' && slot.startTime === '15:45' && location.pathname === '/program') {
            return (
              <div key="opening-talks">
                <ProgramCard
                  key="opening"
                  color={`${day}-color`}
                  endTime="15:45"
                  speakerNames={['Tomáš Volek']}
                  startTime="15:30"
                  talk={{ title: 'Conference Opening' }}
                  tileRole=""
                />
                <ProgramCard
                  key={slot.id}
                  color={`${day}-color`}
                  endTime={slot.endTime}
                  id={slot.id}
                  onCardClick={setSelectedTalk}
                  selectedTalk={selectedTalk}
                  speakerNames={speakerNames}
                  startTime={slot.startTime}
                  talk={{ title: slot.title, youtube: slot.youtube }}
                  tileRole=""
                />
              </div>
            );
          }
          if (day === 'day2' && slot.startTime === '15:40' && location.pathname === '/program') {
            return (
              <div key="opening-talks">
                <ProgramCard
                  key="opening"
                  color={`${day}-color`}
                  endTime="15:40"
                  speakerNames={[]}
                  startTime="15:30"
                  talk={{ title: 'Opening' }}
                  tileRole=""
                />
                <ProgramCard
                  key={slot.id}
                  color={`${day}-color`}
                  endTime={slot.endTime}
                  id={slot.id}
                  onCardClick={setSelectedTalk}
                  selectedTalk={selectedTalk}
                  speakerNames={speakerNames}
                  startTime={slot.startTime}
                  talk={{ title: slot.title, youtube: slot.youtube }}
                  tileRole=""
                />
              </div>
            );
          }
          return (
            <ProgramCard
              key={slot.id}
              color={`${day}-color`}
              endTime={slot.endTime}
              id={slot.id}
              onCardClick={setSelectedTalk}
              selectedTalk={selectedTalk}
              speakerNames={speakerNames}
              startTime={slot.startTime}
              talk={{ title: slot.title, youtube: slot.youtube }}
              tileRole=""
            />
          );
        })}
      </div>
    );
  };

  const renderProgram = () => {
    const filteredTalks =
      location.pathname === '/program'
        ? talks.filter(talk => talk.track === 'Talk')
        : talks.filter(talk => talk.track !== 'Talk');
    const day1 = filteredTalks.filter(talk => talk.conferenceDay === 'day1');
    const day2 = filteredTalks.filter(talk => talk.conferenceDay === 'day2');
    const day3 = filteredTalks.filter(talk => talk.conferenceDay === 'day3');
    const program = { day1, day2, day3 };
    const programDays = ['day1', 'day2', 'day3'];
    const programExists = day1.length > 0 || day2.length > 0 || day3.length > 0;

    return (
      <div className="program-wrapper">
        {programExists ? (
          <>
            {location.pathname === '/workshops'
            // ? (
            // <h2 className="subtitle">Registrations for workshops coming soon.</h2>
            // ) : null
            }
            <div className="is-centered">
              <p>
                Watch the videos of OpenSlava 2020 Expo tech demos and learn how emerging
                technologies can help the businesses and society to address the current challenges.
              </p>
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/playlist?list=PLAUD5QhkPSPN_84CS2aTOF5h4BymoTBKO"
                    rel="noopener noreferrer"
                    target="_blank">
                    OpenSlava 2020 Expo Day 1
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/playlist?list=PLAUD5QhkPSPPqZoe1BNivoTjrL4wHblsr"
                    rel="noopener noreferrer"
                    target="_blank">
                    OpenSlava 2020 Expo Day 2
                  </a>
                </li>
              </ul>
            </div>
            <div className="columns multiline is-desktop">
              {programDays.map(day => renderDayColumn(program[day], day))}
            </div>
          </>
        ) : (
          <h2 className="subtitle">There is no program at this time, stay tuned.</h2>
        )}
      </div>
    );
  };

  return (
    <section className="section" id="program-section">
      <div className="container">
        <h1 className="column">{location.pathname === '/program' ? 'PROGRAM' : 'HANDS-ON LABS'}</h1>
        {!isLoading ? (
          renderProgram()
        ) : (
          <i className="fa fa-spinner fa-spin fa-3x fa-fw" style={{ color: '#7500c0' }} />
        )}
      </div>
    </section>
  );
};

Program.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadProgram: PropTypes.func.isRequired,
  selectedTalk: PropTypes.string.isRequired,
  setSelectedTalk: PropTypes.func.isRequired,
  speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
  talks: PropTypes.arrayOf(PropTypes.any).isRequired
};

const ProgramContainer = (...props) => (
  <ProgramConsumer>
    {({ loadProgram, talks, selectedTalk, speakers, setSelectedTalk, isLoading }) => (
      <Program
        isLoading={isLoading}
        loadProgram={loadProgram}
        selectedTalk={selectedTalk}
        setSelectedTalk={setSelectedTalk}
        speakers={speakers}
        talks={talks}
        {...props}
      />
    )}
  </ProgramConsumer>
);

export default ProgramContainer;
